import { useQuery } from '@tanstack/react-query'

import { fetchManagedVenues } from '@/lib/venue/managerVenueApi'
import type { ManagedVenueListView } from '@/lib/venue/managerVenueTypes'

/**
 * 내 구장 컨텍스트 (#584 §1).
 *
 * 🚨 쿼리 키가 **하나**다 — 구장 선택 화면과 `VenueLayout`(헤더 구장명·소속 검사)이 같은 키를
 * 구독하므로 네트워크 요청이 중복되지 않는다. 구장별 키(`['venue', id, ...]`)와 달리
 * `venueId` 가 들어가지 않는다는 점이 이 EP 의 성질(경로 변수 없음)과 일치한다.
 */
export const MANAGED_VENUES_QUERY_KEY = ['manager', 'venues'] as const

export function useManagedVenues() {
  return useQuery<ManagedVenueListView>({
    queryKey: MANAGED_VENUES_QUERY_KEY,
    queryFn: fetchManagedVenues,
  })
}
